module.exports = __webpack_public_path__ + "static/media/Piercing-ear-scapha.65ac1725.png";